import * as React from "react";
import {
  BooleanInput,
  Create,
  Loading,
  required,
  SelectArrayInput,
  SelectInput,
  SimpleForm,
  TextInput,
  useDataProvider,
  useNotify,
} from "react-admin";
import { TitleExperience } from "./Constant/Constant";
import { SourceCustomer } from "../Admin/Customer";
import { DefaultIsActiveFilter, ExperienceNoteType } from "../../../src/Constants/Constant";
import { useAppDataProvider } from "../../../src/dataprovider";
import CustomLinearProgress from "../../../src/Components/Progress/LinearProgress";
import { useHistory } from "react-router-dom";
import TiptapRichTextInputField from "../../../src/Components/TiptapRichTextInput";

const ExperienceCreate = props => {
  const notify = useNotify();
  const provider = useDataProvider();
  const dataProvider = useAppDataProvider();
  const history = useHistory();
  const [customerList, setCustomerList] = React.useState([] as any);
  const [loading, setLoading] = React.useState(false);
  const onFailure = error => notify(error?.response?.data, { type: "warning" });
  const allSelectedDefaultId = 0;

  React.useEffect(() => {
    getCustomerList();
  }, [props]);

  const getCustomerList = async () => {
    const { data } = await provider.getList(SourceCustomer, {
      pagination: {
        page: 1,
        perPage: 9999,
      },
      sort: { field: "id", order: "DESC" },
      filter: {
        ownerCode__neq: "TTMS",
        ...DefaultIsActiveFilter,
      },
    });
    if (data.length > 0) {
      data.push({ id: allSelectedDefaultId, ownerCode: "ALL" }); //Özellikle All seçimi talep ediyorlar.
      setCustomerList(data.reverse()); // All en üstte görünmesi için reverse ediyorum.
    }
  };

  const handleSubmit = data => {
    setLoading(true);
    dataProvider
      .postExperiencesAddBulk(data)
      .then(result => {
        notify(`Record Created`, "success", false, true);
        history.push("/experiences");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  if (loading) return <Loading />;

  return (
    <Create {...props} title={TitleExperience.create} onFailure={onFailure}>
      <SimpleForm save={handleSubmit}>
        <CustomLinearProgress loading={loading} periodTime={350} />
        <SelectArrayInput
          source="customerIds"
          choices={customerList}
          optionText="ownerCode"
          optionValue="id"
          validate={required()}
        />
        <SelectInput
          source="noteType"
          optionValue="value"
          optionText="noteType"
          choices={ExperienceNoteType}
          validate={[required()]}
        />
        <TextInput source="pn" validate={[required()]} />
        <TiptapRichTextInputField source="remark" validate={[required()]} />

        <BooleanInput source="isShownTt" initialValue={true} />
        <BooleanInput source="isShownCustomer" initialValue={false} />
      </SimpleForm>
    </Create>
  );
};

export default ExperienceCreate;
